// extracted by mini-css-extract-plugin
export default {"boxFirst":"error-bundary_boxFirst__WF6Bf","containerButtonModal":"error-bundary_containerButtonModal__HnmUQ","body":"error-bundary_body__VEAVl"};